/**
 * Remove a prefix from a path
 * @param {Path} path Path to update
 * @param {Path} [prefix=null] Prefix to remove from the path
 * @return {Path} The updated path
 */
function removePathPrefix(path, prefix = null) {
  if (!path) { throw new Error(`Invalid path: ${path}`); }
  if (!prefix) { return path; }
  return (path.startsWith(`${prefix}.`) ? path.slice(`${prefix}.`.length) : null);
}

module.exports = removePathPrefix;
